export class Sitemap{
    loc: string
    constructor(loc?:string){
        this.loc = loc;
    }
}
